import { makeStyles } from "tss-react/mui";
import { Grid, Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import OpenOrdersSection from "./subpages/OpenOrdersSection";
import AllOrdersSection from "./subpages/AllOrdersSection";
import config from "../../../config";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    tabs: {
      marginBottom: theme.spacing(3),
      borderBottom: `1px solid ${theme.palette.divider}`
    },
    tabsSlim: {
      borderBottom: `1px solid ${theme.palette.divider}`
    }
  })
);

export default function OrdersPage() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { tabId } = useParams();
  const { slim } = useDevice();

  const navigate = useNavigate();
  const onTabChange = useCallback((_, val) => navigate(!!tabId ? `../${val}` : `./${val}`, { relative: "path", replace: true }), [navigate, tabId]);

  return (
    <ResponsivePage
      title={t("orders:title")}
      maxWidth={config.pageSize.huge}
    >

      <Grid item xs={12}>
        <Tabs className={slim ? classes.tabsSlim : classes.tabs} value={tabId || "open"} onChange={onTabChange} variant="scrollable" scrollButtons="auto">
          <Tab value="open" label={t("orders:openOrdersTab")} />
          <Tab value="all" label={t("orders:allOrdersTab")} />
        </Tabs>
      </Grid>

      {
        !tabId || tabId === "open" ? (
          <OpenOrdersSection />
        ) : tabId === "all" ? (
          <AllOrdersSection />
        ) : null
      }

    </ResponsivePage>
  );
}

